import ILocationService = angular.ILocationService;

var rkcApp = angular.module('rkcApp', ['ui.router','ngResource', 'ngAnimate', 'ngMaterial','sasrio.angular-material-sidenav', 'md.data.table', 'ngAria', 'ngMessages', 'mdPickers']);

rkcApp
    .config(['$locationProvider', function ($locationProvider) {
        $locationProvider.html5Mode(true);}]
    )
    .factory('defaultResourceErrorHandler', ['$q','$location','$injector',function($q, $location, $injector) {
        return {
            'responseError': function(rejection) {
                if(rejection.status === 401 && $location.url() !== '/login'){
                    var $state = $injector.get('$state');
                    var userService = $injector.get('userService');
                    var toastService = $injector.get('toastService');
                    userService.userDetails = undefined;
                    if($location.$$path !== '/'){
                        toastService.showSimpleToast("Brukeren er ikke logget inn", 3000);
                    }
                    $state.go("login");
                    return $q.reject(rejection);
                }

                return $q.reject(rejection);
            }
        };
    }])
    .config(['$httpProvider',function($httpProvider) {
        $httpProvider.interceptors.push('defaultResourceErrorHandler');
    }])
    .filter('multifilter', ['$filter',function ($filter) {
        return function (collection, query) {
            if(!collection) {
                return;
            }
            if(collection.length){
                var filteredCollection = collection;
                var queryTokens = query ? query.split(' ') : [query];

                // user entered more than word
                if (queryTokens.length > 1) {
                    for (var i = 0; i < queryTokens.length; i++) {
                        filteredCollection = $filter('filter')(filteredCollection, queryTokens[i]);
                    }
                } else {
                    filteredCollection = $filter('filter')(collection, queryTokens[0]);
                }

                return filteredCollection;
            }
        };
    }])
    .directive('format', ['$filter', function ($filter) {
        return {
            require: '?ngModel',
            link: function (scope, elem, attrs, ctrl) {
                if (!ctrl) return;

                ctrl.$formatters.unshift(function (a) {
                    return $filter(attrs.format)(ctrl.$modelValue)
                });

                ctrl.$parsers.unshift(function (viewValue) {
                    var plainNumber = viewValue.replace(/[^\d|\-+|\.+]/g, '');
                    elem.val($filter(attrs.format)(plainNumber));
                    return plainNumber;
                });
            }
        };
    }])
    .directive('ngRightClick', ['$parse', function($parse) {
        return function(scope, element, attrs) {
            var fn = $parse(attrs.ngRightClick);
            element.bind('contextmenu', function(event) {
                scope.$apply(function() {
                    event.preventDefault();
                    fn(scope, {$event:event});
                });
            });
        };
    }])
    .directive('scrolly', function () {
        return {
            restrict: 'A',
            link: function (scope, element, attrs: {scrolly:any}) {
                var raw = element[0];
                element.bind('scroll', function () {
                    if (raw.scrollTop + raw.offsetHeight >= raw.scrollHeight) {
                        scope.$apply(attrs.scrolly);
                    }
                });
            }
        };
    }).filter('numberv2',['$filter', function($filter) {
        return function(value, fractionSize) {
            if(value%1 === 0){
                fractionSize = 0;
            }
            return $filter('number')(value,fractionSize);
        }
    }]);

module.exports = rkcApp;


/** WEBPACK FOOTER **
 ** ./src/app/rkcApp.ts
 **/